import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

export const ICON_SIZE_PX = 40;

export const styleSheet = StyleSheet.create({
	fileInput: {
		display: 'none',
	},
	grid: {
		gap: SPACE[16],
		display: 'grid',
		gridTemplateColumns: 'repeat(3, 340px)',
		justifyContent: 'flex-start',
	},
	utilities: {},
	utilityActions: {
		alignItems: 'center',
		display: 'flex',
		height: SPACE[40],
	},
	utilityCard: {
		alignItems: 'center',
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[24],
		justifyContent: 'space-between',
		padding: `${SPACE[32]}px ${SPACE[20]}px ${SPACE[20]}px`,
		width: 340,
	},
	utilityCardIcon: {
		alignItems: 'center',
		background: THEME.colors.primary.light,
		borderRadius: '50%',
		color: THEME.colors.icon.primary,
		display: 'flex',
		height: 96,
		justifyContent: 'center',
		width: 96,
	},
});
